import React from "react";
import { connect } from "react-redux";
import Promo from "./Promotions";
import StoreInfo from "./StoreInfo";
import ActionButton from "./ActionButton";
import Header from "./Header";
import ProductHeader from "./ProductDetails/ProductHeader";
import { setProduct } from "../store/actions";
import { Sticky, StickyContainer } from "react-sticky";

import ReactPixel from "@bettercart/react-facebook-pixel";
import SnapchatPixel from "react-snapchat-pixel";
import ReactGA from "react-ga4";
import TiktokPixel from "../tiktok-pixel";
import TwitterPixel from "../TwitterPixel";
import { GTM } from "../App";
import Menu from "./Menu";
import GridView from "./GridView";
import LoadingMenu from "./Menu/LoadingMenu";
import LoadingGrid from "./GridView/LoadingGrid";
import LoadingScroll from "./ScrollViewLoading/Menu";
import ScrollView from "./Menu/ScrollView";
import ListViewOld from "./ListViewOld";
import LoadingListOld from "./ListViewOld/LoadingView";
import StaticPages from "./StaticPages";
import BubblesView from "./BubblesView";
import BubbleLoading from "./BubblesView/BubbleLoading";
import { ReactComponent as PoweredByOrdable } from "./assets/poweredByOrdable.svg";
import { ReactComponent as Ordablexdeliverect } from "./assets/Ordablexdeliverect.svg";
import { ReactComponent as Visa } from "./CheckoutProcess/assets/visa.svg";
import { ReactComponent as Mastercard } from "./CheckoutProcess/assets/mastercard.svg";
import ScanQR from "./ScanQR";
import {
  FacebookInitiateCheckout,
  generateUniqueID,
  SnapchatCheckout,
  TikTokInitiateCheckout,
} from "../Helpers/analytics";
import ProductFilter from "./ProductDetails/ProductFilter/ProductFilter";
import FilterHeader from "./ProductDetails/ProductFilter/FilterHeader";
import FilterResult from "./ProductDetails/ProductFilter/FilterResult";
import PreviousOrderAgain from "./PreviousOrderAgain";
import { isEqual } from "./ProductDetails/ProductFilter/helper";
import CategoriesLoading from "./CategoriesHeaders/CategoriesLoading";
import CategoriesHeaders from "./CategoriesHeaders";

class HomePage extends React.Component {
  storeInfo = React.createRef();
  categories_minimum_order = {};
  state = {
    rendered: this.props.store.settings.lazy_load_list ? false : true,
    filterDrawerOpen: false,
  };
  DineInOrderId =
    this.props.settings.enable_table_qr &&
    (localStorage.getItem("dine_in_order_id") ||
      this.props?.address?.dineInOrderID);

  handleFilterDrawerToggle = () => {
    this.setState({ filterDrawerOpen: !this.state.filterDrawerOpen });
    if (this.state.filterDrawerOpen) {
      document.body.style.setProperty("overflow", "auto");
    } else {
      document.body.style.setProperty("overflow", "hidden", "important");
    }
  };
  handleDialogContinue = () => {
    if (this.DineInOrderId && this.props.cart.cart.length <= 0) {
      this.props.history.push(`/track/order/${this.DineInOrderId}`);
      return;
    } else {
      if (this.props.settings.enable_table_qr) {
        this.props.history.push("/checkout/confirmation/");
      } else {
        this.props.history.push("/cart");
        return;
      }
    }
    if (this.props.settings.enable_fb_pixel && this.props.settings.fb_pixel) {
      const eventId = generateUniqueID(10);
      ReactPixel.track(
        "InitiateCheckout",
        {
          event_id: eventId,
          currency: this.props.settings.currency_iso,
          value: this.props.cart.price,
        },
        { eventID: eventId },
      );
      if (this.props.settings.enable_conversion_api) {
        FacebookInitiateCheckout(eventId);
      }
    }
    if (
      this.props.settings.enable_snap_pixel &&
      this.props.settings.snap_pixel
    ) {
      SnapchatCheckout(this.props);
    }
    if (
      this.props.settings.enable_google_analytics &&
      this.props.settings.google_analytics
    ) {
      ReactGA.event({
        category: "orders",
        action: "customer reviews purchase",
        label: "begin_checkout",
      });
    }
    if (GTM) {
      GTM.track("begin_checkout", {
        ecommerce: {
          currency: this.props.settings.currency_iso,
          value: this.props.cart.price,
          items: this.props.cart.cart.map((item) => {
            return {
              item_id: item.id,
              item_name: item.name,
              currency: this.props.settings.currency_iso,
              price: item.total_price + item.quantityExcludedOptionsTotal,
              quantity: item.quantity,
            };
          }),
        },
      });
    }

    if (
      this.props.settings.enable_tiktok_pixel &&
      this.props.settings.tiktok_pixel
    ) {
      TikTokInitiateCheckout(this.props);
    }
    if (TwitterPixel.isInitialized()) {
      if (this.props.settings.twitter_events["Checkout Initiated"]) {
        TwitterPixel.track(
          this.props.settings.twitter_events["Checkout Initiated"],
        );
      }
    }
  };
  handleDialogClaimItems = () => {
    let products = this.state.pending_items;
    this.props.history.replace(
      `/product/${products[0].category}/${
        products[0].parent ? products[0].parent + "/" : ""
      }${products[0].slug}`,
      { pending_items: products.slice(1) },
    );
  };

  componentDidMount = () => {
    this.props.setProduct(null);
    if (!this.state.rendered) {
      window.setTimeout(() => this.setState({ rendered: true }), 1);
    }
    const { baseCountry } = this.props;
    if (baseCountry === "Bahrain") {
      this.loadEfada();
    }
  };
  loadEfada = () => {
    const { domain } = this.props;
    var tag = document.createElement("script");
    tag.async = true;
    tag.src = `https://service.moic.gov.bh/newefadaapi/api/Seal/image?s=https://${domain}&sz=1`;
    var body = document.getElementsByTagName("body")[0];
    body.appendChild(tag);
  };
  // componentWillUnmount() {
  //   window.removeEventListener("scroll", this.handleScroll);
  //   this.unlisten();
  // }

  componentDidUpdate = () => {
    if (
      this.props.settings.hide_categories_layout_all &&
      this.props.selectedCategory == "all" &&
      this.props.settings?.categories_layout !== "none" &&
      !this.props.settings?.store_layout.startsWith("grid")
    ) {
      let firstCategory = this.props.store.categories[0];
      if (firstCategory) {
        this.props.setSelectedCategory(firstCategory);
      }
    }
  };

  cartRequiresAddress = () => {
    const { cart } = this.props;
    if (cart.delivered_items || cart.charged_items) return true;
    return false;
  };

  shouldShowChooseLocationButton = () => {
    const { settings, no_address } = this.props;
    if (!settings.is_branch_based_ordering && settings.is_menu) return false;

    if (no_address) return false;

    if (
      settings.only_booking == true ||
      (settings.enable_pickup == false && settings.enable_delivery == false)
    )
      return false;
    let totalCartLength =
      this.props.cart.cart.length + this.props.cart.promo_items.length;

    if (totalCartLength > 0 && !this.cartRequiresAddress()) return false;
    if (settings.is_branch_based_ordering && !this.props.branch.branch)
      return true;

    if (
      !settings.is_branch_based_ordering &&
      !this.props.address?.area &&
      !this.props.address?.pickupArea
    )
      return true;
    return false;
  };

  shouldShowCheckoutButton = () => {
    const { settings } = this.props;
    if (settings.is_menu) return false;
    let totalCartLength =
      this.props.cart.cart.length + this.props.cart.promo_items.length;

    if (totalCartLength === 0 && !this.DineInOrderId) return false;
    if (!this.cartRequiresAddress()) return true;
    if (settings.is_branch_based_ordering && !this.props.branch) return false;
    if (
      !settings.is_branch_based_ordering &&
      (this.props.address?.area || this.props.address?.pickupArea)
    )
      return true;
    return true;
  };

  checkIfAnyFilterApplied = () => {
    const {
      filtersSelected,
      sortBy,
      priceRange,
      categoriesFilter,
      availableProducts,
      nutritionalFact,
    } = this.props;
    return (
      filtersSelected.length > 0 ||
      sortBy.value !== "" ||
      priceRange !== null ||
      categoriesFilter.length > 0 ||
      availableProducts === true ||
      !isEqual(nutritionalFact, {
        calories: null,
        carbs: null,
        fats: null,
        protein: null,
        dietaryRestrictions: [],
      })
    );
  };

  render() {
    const {
      language,
      settings,
      store,
      address,
      lastOrder,
      selectedCategory,
      baseCountry,
    } = this.props;

    let customTexts = this.props.settings.custom_texts;
    if (!customTexts) {
      customTexts = {
        review_order: "Review Order",
        review_order_ar: "مراجعة الطلب",
        select_location: "Select your location",
        select_location_ar: "اختر منطقتك",
      };
    }

    let totalCartLength =
      this.props.cart.cart.length + this.props.cart.promo_items.length;
    if (settings.enable_table_qr && !address?.parkingNumber) return <ScanQR />;

    return (
      <>
        {settings.enable_filter_and_sort && this.state.filterDrawerOpen && (
          <ProductFilter
            filterDrawerOpen={this.state.filterDrawerOpen}
            handleFilterDrawerToggle={this.handleFilterDrawerToggle}
          />
        )}
        <div className="d-lg-none d-xl-none d-md-none">
          <ProductHeader
            filterDrawerOpen={this.state.filterDrawerOpen}
            homePage={true}
            storeInfoRef={this.storeInfo}
            appRef={this.props.appRef}
            enableSearch={true}
          />
        </div>
        {settings.show_cover && (
          <div
            className="col-12 d-lg-none d-xl-none d-md-none p-0"
            style={{ height: 300, width: "100%", marginTop: "54.5px" }}
          >
            <Header imageSize={300} />
          </div>
        )}
        <StoreInfo />

        <span ref={this.storeInfo}></span>
        {!settings.is_menu &&
          settings.show_previous_orders_homepage &&
          this.props.pastOrders.length > 0 && (
            <PreviousOrderAgain history={this.props.history} />
          )}
        {this.props.promos && <Promo />}
        {settings.enable_filter_and_sort && (
          <FilterHeader
            handleFilterDrawerToggle={this.handleFilterDrawerToggle}
            checkIfAnyFilterApplied={this.checkIfAnyFilterApplied}
          />
        )}

        <StickyContainer>
          {settings.categories_layout !== "none" && (
            <Sticky
              topOffset={document.documentElement.clientWidth > 767 ? 0 : -54}
            >
              {({ style, isSticky }) => (
                <div
                  style={
                    this.props.settings.categories_layout_sticky
                      ? { ...style, zIndex: 999 }
                      : {}
                  }
                  className="sticky-category"
                >
                  {settings.categories_layout !== "none" &&
                  this.props.secondLoading ? (
                    <CategoriesLoading
                      categoriesStyle={settings.categories_layout}
                    />
                  ) : this.state.rendered &&
                    this.props.store.categories.length ? (
                    !this.checkIfAnyFilterApplied() ? (
                      <CategoriesHeaders
                        categoriesStyle={settings.categories_layout}
                        selectedCategory={selectedCategory}
                        history={this.props.history}
                        store={this.props.store}
                        isSticky={isSticky}
                      />
                    ) : null
                  ) : null}
                </div>
              )}
            </Sticky>
          )}
          <div>
            {this.props.secondLoading ? (
              settings.store_layout === "list" ||
              settings.store_layout === "jumbo" ? (
                <LoadingMenu settings={this.props.store.settings} />
              ) : settings.store_layout === "grid" ||
                settings.store_layout === "grid2" ? (
                <LoadingGrid
                  cellHeight={240}
                  settings={this.props.store.settings}
                />
              ) : settings.store_layout == "list-collapse" ? (
                <LoadingListOld language={language} />
              ) : settings.store_layout === "bubbles" ? (
                <BubbleLoading settings={settings} />
              ) : (
                <LoadingScroll language={language} />
              )
            ) : this.state.rendered && this.props.store.categories.length ? (
              this.checkIfAnyFilterApplied() &&
              settings.enable_filter_and_sort ? (
                <FilterResult />
              ) : settings.store_layout === "list" ||
                settings.store_layout === "jumbo" ? (
                <Menu />
              ) : settings.store_layout === "grid" ||
                settings.store_layout === "grid2" ? (
                <GridView history={this.props.history} />
              ) : settings.store_layout === "list-collapse" ? (
                <ListViewOld />
              ) : settings.store_layout === "bubbles" ? (
                <BubblesView history={this.props.history} />
              ) : (
                <ScrollView history={this.props.history} />
              )
            ) : null}
          </div>
        </StickyContainer>

        <StaticPages from="HomePage" />

        {!this.props.store.settings.is_whitelabel &&
          (window.location.host === "deliverect.ordable.com" ? (
            <p
              className="text-center w-100 mb-4"
              style={{ fontWeight: "bold" }}
            >
              <Ordablexdeliverect
                alt="powered by ordable/"
                style={{ width: 300, height: 75, cursor: "pointer" }}
                onClick={() =>
                  window
                    .open(
                      `https://www.itsordable.com/?utm_source=${window.location.hostname}&utm_medium=store&utm_campaign=powered_by&utm_content=${language}`,
                      "_blank",
                    )
                    .focus()
                }
              />
            </p>
          ) : (
            <p
              className="text-center w-100 mb-4"
              style={{
                fontWeight: "normal",

                position: "relative",
                top: "-5px",
              }}
            >
              <a
                href={`https://www.itsordable.com/?utm_source=${window.location.hostname}&utm_medium=store&utm_campaign=powered_by&utm_content=${language}`}
                target="_blank"
                style={{
                  color: "#666",
                  fontSize: "12px",
                }}
              >
                {language === "english"
                  ? "powered by ordable/"
                  : "/بدعم من اوردبل"}
              </a>
            </p>
          ))}

        {settings?.enable_myfatoorah && settings?.currency_iso === "JOD" && (
          <>
            <Visa width="30" height="30" />
            <Mastercard width="30" height="30" />
          </>
        )}
        {baseCountry === "Bahrain" && <div id="efadaDiv">&nbsp;</div>}

        <div className="free-space-60"></div>

        {this.shouldShowCheckoutButton() ? (
          <ActionButton
            action={
              this.DineInOrderId && this.props.cart.cart.length <= 0
                ? language == "english"
                  ? "Pay"
                  : "ادفع"
                : language == "english"
                  ? customTexts.review_order
                  : customTexts.review_order_ar
            }
            onClick={() => {
              this.handleDialogContinue();
            }}
            total={
              this.DineInOrderId && this.props.cart.cart.length <= 0
                ? null
                : this.props.cart.price.toFixed(settings.currency_decimals)
            }
            quantity={totalCartLength > 0 ? totalCartLength : null}
          />
        ) : null}
        {this.shouldShowChooseLocationButton() ? (
          <ActionButton
            action={
              language == "english"
                ? customTexts.select_location
                : customTexts.select_location_ar
            }
            allowWithMenu
            onClick={() => this.props.history.push("/select/branch")}
          />
        ) : null}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    labels: state.store.labels,
    store: state.store.store,
    cart: state.cart,
    promos: state.store.store.promos,
    settings: state.store.store.settings,
    branch: state.branch,
    discounts: state.cart.discounts,
    cart_categories_min: state.cart.categories_min_order,
    secondLoading: state.store.secondLoading,
    address: state.customers.address,
    no_address: state.store.store.no_address,
    filtersSelected: state.productFilter.filtersSelected,
    sortBy: state.productFilter.sortBy,
    priceRange: state.productFilter.priceRange.range,
    categoriesFilter: state.productFilter.selectedCategories,
    availableProducts: state.productFilter.availableProducts,
    nutritionalFact: state.productFilter.nutritionalFact,
    pastOrders: state.PastOrders.pastOrders,
    userId: state.auth.user,
    lastOrder: state.PastOrders.lastOrder,
    selectedCategory: state.selectedCategoryHeader.selectedCategory,
    baseCountry: state.store.store.base_country,
    domain: state.store.store.domain,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setProduct: (prd) => dispatch(setProduct(prd)),
    setSelectedCategory: (category) =>
      dispatch({ type: "SET_SELECTED_CATEGORY", payload: category }),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
